import axios from "axios";
import { useEffect, useState } from "react";
import { FiPackage } from "react-icons/fi";
import { GrView } from "react-icons/gr";
import { useNavigate } from "react-router-dom";

export default function PickupRequests() {
   const navigate = useNavigate();
   const [requests, setRequests] = useState([]);

   const [searchTerm, setSearchTerm] = useState("");
   const [pickupRequests, setPickupRequests] = useState([]);
   const [currentPage, setCurrentPage] = useState(1);
   const itemsPerPage = 7;

   useEffect(() => {
      const rc_id = sessionStorage.getItem('rc_id');
      if (rc_id) {
         axios.get(`/auth/redem-pickup-requests-by-rc?rc_id=${rc_id}`)
            .then(res => {
               setRequests(res.data);
               setPickupRequests(res.data);
            })
            .catch(err => console.error(err));
      }
   }, []);

   // 🔍 Search filter
   const filteredRequests = requests.filter((request) => {
      const search = searchTerm.toLowerCase();
      return (
         request.id?.toString().includes(search) ||
         `${request.first_name} ${request.last_name}`.toLowerCase().includes(search) ||
         request.driver_assigned?.toLowerCase().includes(search) ||
         request.pickup_status?.toLowerCase().includes(search) ||
         new Date(request.pickup_date).toLocaleDateString("en-US").includes(search)
      );
   });

   // 📄 Pagination logic
   const totalPages = Math.ceil(filteredRequests.length / itemsPerPage);
   const startIndex = (currentPage - 1) * itemsPerPage;
   const currentRequests = filteredRequests.slice(startIndex, startIndex + itemsPerPage);

   // Function to generate pagination numbers with dots
   const getPageNumbers = () => {
      const pages = [];
      if (totalPages <= 6) {
         for (let i = 1; i <= totalPages; i++) pages.push(i);
      } else {
         if (currentPage <= 3) {
            pages.push(1, 2, 3, 4, "...", totalPages);
         } else if (currentPage >= totalPages - 2) {
            pages.push(1, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
         } else {
            pages.push(1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages);
         }
      }
      return pages;
   };

   const renderStatusBadge = (status) => {
      switch (status.toLowerCase()) {
         case "pending":
            return <span className="bg-red-200 text-red-800 text-xs font-medium px-2 py-1 rounded-lg">Pending</span>;
         case "assigned":
            return <span className="bg-yellow-200 text-yellow-800 text-xs font-medium px-2 py-1 rounded-lg">Assigned</span>;
         case "completed":
            return <span className="bg-green-200 text-green-800 text-xs font-medium px-2 py-1 rounded-lg">Completed</span>;
         default:
            return <span className="bg-gray-200 text-gray-800 text-xs font-medium px-2 py-1 rounded-lg">{status}</span>;
      }
   };

   return (
      <div className="p-4">
         <div className="bg-white shadow-md rounded-2xl p-5 w-full">

            {/* Header + Search */}
            <div className="flex flex-col items-center gap-4 sm:flex-row sm:justify-between mb-6 px-4">
               <h2 className="flex items-center gap-2 text-2xl font-bold text-green-800">
                  <FiPackage className="text-3xl" /> Pickup Requests
               </h2>
               <input
                  type="text"
                  placeholder="Search by request ID, name, driver, status, or date..."
                  value={searchTerm}
                  onChange={(e) => {
                     setSearchTerm(e.target.value);
                     setCurrentPage(1); // reset to first page when searching
                  }}
                  className="w-full max-w-sm px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-green-500"
               />
            </div>

            {/* Table */}
            <div className="w-full overflow-x-auto">
               <table className="mx-1 min-w-max w-full border border-gray-200 text-sm">
                  <thead className="bg-lime-100 text-green-900 uppercase font-semibold">
                     <tr>
                        <th className="px-2 py-4">S.no</th>
                        <th className="px-2 py-4">Request ID</th>
                        <th className="px-2 py-4">Customer</th>
                        <th className="px-2 py-4">Address</th>
                        <th className="px-3 py-4">Pickup Date</th>
                        <th className="px-3 py-4">Pickup Time</th>
                        <th className="px-2 py-4">Status</th>
                        <th className="px-2 py-4">Assigned To</th>
                        <th className="px-2 py-4">Actions</th>
                     </tr>
                  </thead>
                  <tbody>
                     {currentRequests.length > 0 ? (
                        currentRequests.map((request, index) => (
                           <tr key={request.id} className="bg-white border-b hover:bg-gray-50">
                              <td className="px-3 py-4 text-center">{startIndex + index + 1}</td>
                              <td className="px-3 py-4 text-center">{request.id}</td>
                              <td className="px-3 py-4 text-center">
                                 {request.first_name} {request.last_name}
                              </td>
                              <td className="px-3 py-4 text-center">{request.street_address}</td>
                              <td className="px-4 py-4 text-center">
                                 {/* {new Date(request.pickup_date).toLocaleDateString("en-US")} */}
                                 {request.pickup_date ? request.pickup_date.split("T")[0] : ""}
                              </td>
                              <td className="px-4 py-4 text-center">{request.pickup_time}</td>
                              <td className="px-4 py-4 text-center">{renderStatusBadge(request.pickup_status)}</td>
                              <td className="px-4 py-4 text-center">
                                 {request.driver_assigned ? (
                                    <span>
                                       <span className="text-red-600 font-semibold">
                                          {request.driver_assigned} -
                                       </span>{" "}
                                       {request.driver_first_name || ""} {request.driver_last_name || ""}
                                    </span>
                                 ) : (
                                    "Not Assigned"
                                 )}
                              </td>
                              <td className="px-4 py-4 flex justify-center gap-4 text-center">
                                 <button
                                    onClick={() => navigate(`/redem-view-pickupreq/${request.id}`)}
                                    className="text-black-800 hover:text-black-800"
                                 >
                                    <GrView />
                                 </button>
                                 <button
                                    onClick={() => navigate(`/redem-assign-pickupreq/${request.id}`)}
                                    disabled={request.pickup_status?.toLowerCase() === "completed"}
                                    className={`px-4 py-2 rounded-lg text-white ${request.pickup_status?.toLowerCase() === "completed"
                                       ? "bg-gray-400 cursor-not-allowed"
                                       : "bg-orange-700 hover:bg-orange-600"
                                       }`}
                                 >
                                    Assign Driver
                                 </button>
                              </td>
                           </tr>
                        ))
                     ) : (
                        <tr>
                           <td colSpan="9" className="text-center py-6">No pickup requests found.</td>
                        </tr>
                     )}
                  </tbody>
               </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
               <div className="flex justify-center mt-6 gap-2">
                  <button
                     disabled={currentPage === 1}
                     onClick={() => setCurrentPage((prev) => prev - 1)}
                     className="px-3 py-1 border rounded-md disabled:opacity-50"
                  >
                     &lt;
                  </button>

                  {getPageNumbers().map((page, index) =>
                     page === "..." ? (
                        <span key={index} className="px-3 py-1">...</span>
                     ) : (
                        <button
                           key={index}
                           onClick={() => setCurrentPage(page)}
                           className={`px-3 py-1 border rounded-md ${currentPage === page ? "bg-[#a3e635] text-white" : ""}`}
                        >
                           {page}
                        </button>
                     )
                  )}

                  <button
                     disabled={currentPage === totalPages}
                     onClick={() => setCurrentPage((prev) => prev + 1)}
                     className="px-3 py-1 border rounded-md disabled:opacity-50"
                  >
                     &gt;
                  </button>
               </div>
            )}
         </div>
      </div>
   );
}
